import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { enOrderBumpStatus, enOrderBumpStatusBase } from 'types/enums';
import { IOrderBumpPreview } from 'types/interfaces';

export const initialState: IOrderBumpPreview = {
  id: 0,
  contentId: 0,
  title: '',
  items: [],
  bumpItemsLimit: 3,
  status: enOrderBumpStatus.ERROR,
  hasChange: false
};

const orderBumpPreviewSlice = createSlice({
  name: 'Order Bump Preview',
  initialState,
  reducers: {
    reset(state) {
      state = initialState;
      return state;
    },
    setState(state, action: PayloadAction<IOrderBumpPreview>) {
      state = action.payload;
      return state;
    },
    setCondition(state, action: PayloadAction<enOrderBumpStatusBase>) {
      state.condition = action.payload;
      return state;
    },
    setHasChange(state, action: PayloadAction<boolean>) {
      state.hasChange = action.payload;
      return state;
    }
  }
});

export const orderBumpPreviewActions = orderBumpPreviewSlice.actions;
export default orderBumpPreviewSlice.reducer;
